import { usePermissions } from "../../Context/PermissionContext";
import { FEATURE_CODES } from "../../Static/FeatureMapping";

/**
 * Whether a screen uses the RBAC fleet and location lists (/api/rbac/me/fleets,
 * /api/rbac/me/locations) and the customer-account + hierarchical location filter,
 * or the legacy lists (/api/v1/fleets + onboarding locations) and the location-only
 * filter.
 *
 * This is a version switch, not a permission check, so hasPermission alone is the
 * wrong test: on RBAC v1 it returns true for every feature code. The RBAC lists read
 * userFleetAssignment, which a v1 org does not maintain, so a v1 admin got an empty
 * fleet list and every page gated on it rendered blank. v1 orgs therefore always
 * take the legacy lists.
 *
 * @param {Function} hasPermission   - (featureCode, operation) => boolean
 * @param {Function} isRbacV2Enabled - () => boolean
 * @returns {boolean}
 */
export const canUseGlobalAdvancedFilter = (hasPermission, isRbacV2Enabled) =>
  Boolean(isRbacV2Enabled?.()) &&
  Boolean(hasPermission?.(FEATURE_CODES.GLOBAL_ADVANCED_FILTER, "view"));

/** Hook form of canUseGlobalAdvancedFilter for the current user. */
export const useCanUseGlobalAdvancedFilter = () => {
  const { hasPermission, isRbacV2Enabled } = usePermissions();
  return canUseGlobalAdvancedFilter(hasPermission, isRbacV2Enabled);
};
